var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVecSupportMemoOtherPink24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "@color/pink_400",
  d: "M216.642 420.804V314.965l158.903-158.903V11.725H0v488.55h375.545V367.738l-53.066 53.066zM502.959 154.349l-19.882-19.873c-12.054-12.064-31.606-12.054-43.66 0l-18.598 18.607 63.542 63.542 18.596-18.598c12.057-12.063 12.057-31.615.002-43.678z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "@color/pink_400",
  d: "M246.553 327.35v63.543h63.542l156.936-156.938-63.542-63.541z"
})));
export default SvgVecSupportMemoOtherPink24;